import { createLifecycleFor } from 'ext/lib/collections';

export const TYPE = 'userAccounts' as const;

export const { resolve, reject, patterns } = createLifecycleFor(TYPE);
